export default __webpack_public_path__ + "static/0271-96ad06603b868fc7db32b65bf49792e9.png";